
import { Vue, Component, Prop } from "vue-property-decorator";

import UPDATE_WEBSITE from "@/apollo/profile/website/UpdateWebsite.gql";
import GET_WEBSITE from "@/apollo/profile/website/GetWebsite.gql";

import FormWrapper from "@/components/form/FormWrapper.vue"
import UiButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroup.vue";

import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import UserResume from "@/entities/UserResume";

interface Observer extends Vue {
  reset: Function;
}

@Component({
  components: {
    FormWrapper,
    FormGroup,
    UiButton,
  },
  apollo: {
    website: {
      query: GET_WEBSITE,
      variables() {
        return {
          id: this.userId,
        };
      },
      update (data) {
        const website = data.user_profile_by_pk.website;
        this.initialWebsiteValue = website;
        return website;
      },
    },
  },
})
export default class ProfileWebsite extends Vue {
  @Prop({ type: String, required: true }) readonly userId!: string;

  website: string = "";
  initialWebsiteValue: string = "";
  updating: boolean = false;
  deleting: boolean = false;

      /**
     * ==========================[qtrinh@ideatheorem.com]==========================
     * have created function to render listener once in the component cycle and populate user data
     * Make sure to destroy
     * 
     * TODO: We need to populate country, province, postalcode, and city
     */
     created() {
      this.$eventBus.listen(UserResume.UPDATE_RESUME, (data: any) => {
        const scrappedResume = data.data
        if (scrappedResume)
        {
          if (scrappedResume.hasOwnProperty("websites"))
          {
            this.website = scrappedResume.websites.at(-1);
          }
        }
      })
    }

    beforeDestroy() {
      this.$eventBus.remove(UserResume.UPDATE_RESUME)
    }
    /**
     * ==========================[qtrinh@ideatheorem.com]==========================
     */

  get fetching(): boolean {
    return this.$apollo.queries.website.loading;
  }

  get websiteUpdateNeeded(): boolean {
    return this.websiteChanged;
  }

  get existingWebsiteUpdated(): boolean {
    return Boolean(this.initialWebsiteValue && this.website && this.initialWebsiteValue !== this.website);
  }

  get websiteDeleted(): boolean {
    return Boolean(this.initialWebsiteValue && !this.website);
  }

  get websiteAdded(): boolean {
    return Boolean(!this.initialWebsiteValue && this.website);
  }

  get websiteChanged(): boolean {
    return this.existingWebsiteUpdated
    || this.websiteDeleted
    || this.websiteAdded;
  }

  get websiteValuePresent(): boolean {
    return Boolean(this.website);
  }

  async updateWebsite(): Promise<void> {
    if (!this.websiteUpdateNeeded) {
      this.handleWarningNotifications();
      return;
    }

    this.setUpdatePurpose();

    try {
      await this.update();

      const purpose = this.website ? "updated" : "deleted";
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(`Your website url had been successfully ${purpose}.`)
      );
      this.refetch();
    } catch (error) {
      this.$eventBus.emit(
        NOTIFICATION,
        Message.errorMessage(error.message)
      );
    } finally {
      this.updating = false;
      this.deleting = false;
    }
  }

  async update(): Promise<void> {
    await this.$apollo.mutate({
      mutation: UPDATE_WEBSITE,
      variables: {
        id: this.userId,
        website: this.website,
      },
    });
  }

  refetch(): void {
    this.$apollo.queries.website.refetch();
    this.$emit("update");
  }

  removeWebsite(): void {
    this.website = "";
    (this.$refs.observer as Observer).reset();
    this.updateWebsite();
  }

  handleWarningNotifications(): void {
    if (!this.websiteValuePresent) {
      this.$eventBus.emit(
        NOTIFICATION,
        Message.infoMessage("Please, enter your website before submitting"),
      );
      return;
    }

    if (!this.websiteChanged) {
      this.$eventBus.emit(
        NOTIFICATION,
        Message.infoMessage("You haven't updated your website"),
      );
      return;
    }
  }

  setUpdatePurpose(): void {
    if (this.website) {
      this.updating = true;
    }
    if (this.initialWebsiteValue && !this.website) {
      this.deleting = true;
    }
  }
}
